module.exports = __webpack_public_path__ + "static/media/news_2.9f9ff65a.png";